import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Chakra+Petch:wght@300;400;500;600;700&family=Rajdhani:wght@500;600;700&display=swap');

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: ${props => props.theme.fonts.body};
    background: ${props => props.theme.gradients.background || props.theme.colors.background};
    color: ${props => props.theme.colors.text};
    transition: background-color 0.3s ease, color 0.3s ease;
    line-height: 1.5;
    --legacy-card-bg: ${props => props.theme.profile?.cards?.background ?? 'var(--legacy-card-bg)'};
    --legacy-card-border: ${props => props.theme.profile?.cards?.border ?? props.theme.colors?.borderLight ?? 'rgba(0, 212, 255, 0.3)'};
  }

  a {
    text-decoration: none;
    color: ${props => props.theme.colors.primary};
  }

  button {
    cursor: pointer;
    border: none;
    outline: none;
    font-family: ${props => props.theme.fonts.body};
    color: ${props => props.theme.colors.text};
  }
`;

export default GlobalStyles;
